import React, { useState } from 'react';

/**
 * The firm's own branding - custom text or an uploaded logo - printed in the top
 * LEFT of page 1 of a report. Set firm-wide from Manual > Report Branding, so it
 * is the same mark for every user of the firm.
 *
 * Distinct from ReportLogo (the bundled Banyan mark, top RIGHT, per-window
 * toggle). Renders nothing when the firm has set no branding, and removes itself
 * if the stored image fails to decode so a bad upload degrades to nothing rather
 * than a broken-image icon. The report body is always white, so the text is
 * dark-ink regardless of the app theme.
 */
const ReportBrandMark = ({ brand }) => {
  const [failed, setFailed] = useState(false);
  if (!brand) return null;
  if (brand.logo_data_url && !failed) {
    return (
      <div className="report-brand-mark" data-testid="report-brand-mark">
        <img
          src={brand.logo_data_url}
          alt=""
          className="h-14 w-auto object-contain"
          onError={() => setFailed(true)}
        />
      </div>
    );
  }
  if (brand.text) {
    return (
      <div
        className="report-brand-mark text-sm font-semibold whitespace-pre-line text-gray-900"
        data-testid="report-brand-mark"
      >
        {brand.text}
      </div>
    );
  }
  return null;
};

export default ReportBrandMark;
